import { LogLevel } from 'features/observability/logger/log-level';

import { Loggable } from '@rbi-ctg/frontend';

// `LogLevel` now lives with the vendor-neutral logger core. Re-exported here so
// existing importers of `features/observability/datadog/types` keep resolving.
export { LogLevel } from 'features/observability/logger/log-level';

export const UNKNOWN_ERROR_MESSAGE = 'Unknown application error. Unable to parse error message.';

interface Context {
  [x: string]: Loggable | Loggable[];
}

export interface IDatadogLogger {
  context?: Context;
  message: Loggable;
  status: LogLevel;
}
